import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Container from '../../../components/Container';
import Teaser from '../../../components/Teaser';
import TeaserSmall from '../../../components/TeaserSmall';
import { DEFAULT_FADE_DURATION_MS } from '../../../config/constants';

import './style.scss';

const NewsSelection = ({ entities, title }) => {
  let main = [];
  let rest = [];

  entities.map((entity, index) => {
    index === 0
      ? main.push(entity)
      : rest.push(entity);
  });

  return (
    <div className="NewsSelection">
      <Container>
        {title && <h2>{title}</h2>}
        <div className="NewsSelection__wrapper">
          {main.length > 0 && main.map((entity) => {
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            return (
              <div key={`${uuid}:${langcode}`} className="NewsSelection__main">
                <Fade triggerOnce duration={DEFAULT_FADE_DURATION_MS}>
                  <Teaser
                    entity={entity}
                    showDate
                    showBody
                  />
                </Fade>
              </div>
            );
          })}
          <div className="NewsSelection__rest">
            {rest.length > 0 && rest.map((entity) => {
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              return (
                <div key={`${uuid}:${langcode}`}>
                  <Fade triggerOnce duration={DEFAULT_FADE_DURATION_MS}>
                    <TeaserSmall
                      entity={entity}
                      showDate
                    />
                  </Fade>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NewsSelection;
